import React from 'react';
import { useSelector } from 'react-redux';
import { pageContext } from 'ctm-util-functions';
import { getBrand } from '../store/selectors';

export const useEverestConfig = () => {
    const verticalName = pageContext.getVertical();
    const brandcode = useSelector(getBrand);

    return {
        brandcode,
        verticalName
    };
};
